var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","width":"20","height":"20","x":"0","y":"0","maskUnits":"userSpaceOnUse","key":0},React.createElement("path",{"fill":"#fff","fillRule":"evenodd","d":"M0 0h20v20H0V0Z","clipRule":"evenodd"})),React.createElement("g",{"mask":"url(#a)","key":1},React.createElement("path",{"fill":"#A28D70","fillRule":"evenodd","d":"M8.5 16C4.364 16 1 12.636 1 8.5S4.364 1 8.5 1 16 4.364 16 8.5 12.636 16 8.5 16Zm11.354 3.146-5-5c-.003-.002-.008-.003-.011-.007C16.18 12.637 17 10.665 17 8.5 17 3.813 13.187 0 8.5 0 3.813 0 0 3.813 0 8.5 0 13.187 3.813 17 8.5 17c2.165 0 4.137-.82 5.639-2.157.004.003.005.008.007.011l5 5c.098.097.226.146.354.146.128 0 .256-.049.354-.146.195-.196.195-.512 0-.708Z","clipRule":"evenodd"}))]);
}

Search.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Search;

Search.default = Search;
